import { HTMLStencilElement } from '@stencil/core/internal';

/**
 * Asynchronously executes the provided function after all the Stencil
 * children of the provided element are ready per the onComponentReady
 * function.  Adds an additional 50 milliseconds for browser processing of the
 * new custom element(s)
 *
 * @param element element with children to check
 * @param func function to execute when they are ready.
 */
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
const onChildrenReady = async (element: HTMLElement, func: Function) => {
  const children = element.getElementsByTagName('*');
  let readyCount = 0;
  let stencilChildren = 0;

  Array.from(children).map(child => {
    if ((child as HTMLStencilElement).componentOnReady) {
      stencilChildren++;
      (child as HTMLStencilElement).componentOnReady().then(() => {
        readyCount++;
        if (readyCount === stencilChildren) {
          const timer = window.setTimeout(() => {
            func();
            window.clearTimeout(timer);
          }, 50);
        }
      });
    }
    return true;
  });
};

export default onChildrenReady;
